import React from "react";
import "./Light_Blue_Btn.css";
import { Button } from "react-bootstrap";

const Light_Blue_Btn = ({ btnText, onClick }) => {
  return (
    <button className="Light_Blue_Btn" onClick={onClick}>
      {btnText}
    </button>
  );
};

export default Light_Blue_Btn;
